<template>
  <ul class="space-y-1">
    <li
      v-for="funnel in funnels"
      :key="funnel.id"
      :class="[funnel.id === currentFunnelId ? 'bg-gray-100 rounded-md' : '']"
    >
      <label class="px-3 py-2 text-sm flex flex-1 items-center select-none">
        <input v-model="currentFunnelId" type="radio" :value="funnel.id" class="hidden" />
        <span class="flex-1 truncate">
          {{ funnel.name }}
        </span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    funnels: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    currentFunnelId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
